import { MenuItem, Select, SelectChangeEvent, Stack, Typography, useTheme } from '@mui/material';

interface TimePicklistInputProps {
	value: string;
	onChange: (next: string) => void;
	label?: string;
	disabled?: boolean;
}

const HOURS_IN_DAY = 24;
const TIME_INTERVAL_MINUTES = 30;
const MINUTES_IN_HOUR = 60;

const formatHour = (hour: number) => String(hour).padStart(2, '0');

const createTimeOptions = (): string[] => {
	const options: string[] = [];
	for (let hour = 0; hour < HOURS_IN_DAY; hour++) {
		for (let minute = 0; minute < MINUTES_IN_HOUR; minute += TIME_INTERVAL_MINUTES) {
			options.push(`${formatHour(hour)}:${String(minute).padStart(2, '0')}`);
		}
	}
	return options;
};

const TIME_OPTIONS = createTimeOptions();

export const TimePicklistInput = ({ value, onChange, label, disabled }: TimePicklistInputProps) => {
	const theme = useTheme();
	const handleChange = (event: SelectChangeEvent<string>) => {
		onChange(event.target.value);
	};

	return (
		<Stack direction="row" alignItems="center" gap="8px">
			{label && (
				<Typography sx={{ fontSize: 12, minWidth: 40, color: theme.palette.root.border_teal }}>
					{label}
				</Typography>
			)}
			<Select
				value={value}
				onChange={handleChange}
				size="small"
				disabled={disabled}
				inputProps={{ 'aria-label': label }}
				sx={{
					height: 34,
					minWidth: 90,
					borderRadius: '8px',
					direction: 'ltr',
					fontVariantNumeric: 'tabular-nums',
					'& .MuiSelect-select': {
						borderRadius: '8px',
					},
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: theme.palette.root.mediumGreen,
						borderRadius: '8px',
					},
					'&:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: theme.palette.root.inputFocusGreen,
					},
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: theme.palette.root.inputFocusGreen,
					},
				}}
			>
				{TIME_OPTIONS.map((opt) => (
					<MenuItem key={opt} value={opt}>
						{opt}
					</MenuItem>
				))}
			</Select>
		</Stack>
	);
};
